import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "totals text-right" }
const _hoisted_2 = {
  class: "totals text-right",
  style: {"font-weight":"normal"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: _ctx.formIsValid,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formIsValid) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "8",
            class: "text-subtitle-1 px-3 pt-2"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Les acomptes de la facture ")
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "4",
            class: "px-3 pt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                modelValue: _ctx.displayPercentageAndDisableAmount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayPercentageAndDisableAmount) = $event)),
                "hide-details": "",
                label: "En pourcentage",
                class: "my-0 py-0"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "px-3 pt-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDeposits, (depo, index) => {
                return (_openBlock(), _createBlock(_component_v_row, {
                  "no-gutters": "",
                  key: index + '_deposit',
                  class: "d-flex justify-center pb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: depo.name,
                          "onUpdate:modelValue": ($event: any) => ((depo.name) = $event),
                          label: "Nom de l'acompte",
                          rules: [_ctx.rules.notEmpty],
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_date_picker_filled, {
                          modelValue: depo.date,
                          "onUpdate:modelValue": ($event: any) => ((depo.date) = $event),
                          label: "Date",
                          rules: [_ctx.rules.notEmpty]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _: 2
                    }, 1024),
                    (_ctx.displayPercentageAndDisableAmount)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "2",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: depo.percentage,
                              "onUpdate:modelValue": [($event: any) => ((depo.percentage) = $event), ($event: any) => (_ctx.adaptDepositLine('amount', index))],
                              text: _ctx.limit2decimals(depo.percentage),
                              type: "number",
                              suffix: "%",
                              rules: [_ctx.rules.notEmpty, _ctx.rules.isPercentage],
                              density: "compact"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "text", "rules"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_col, {
                      cols: _ctx.displayPercentageAndDisableAmount ? '2' : '4',
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_text_field_filled, {
                          modelValue: depo.amount,
                          "onUpdate:modelValue": ($event: any) => ((depo.amount) = $event),
                          text: _ctx.limit2decimals(depo.amount),
                          outlined: "",
                          dense: "",
                          suffix: "€",
                          rules: [_ctx.rules.notEmpty, _ctx.rules.isCorrectAmount],
                          disabled: _ctx.displayPercentageAndDisableAmount,
                          onChange: ($event: any) => (_ctx.adaptDepositLine('percentage', index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "text", "rules", "disabled", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["cols"]),
                    _createVNode(_component_v_col, {
                      col: "1",
                      class: "d-flex align-center justify-center"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.newDeposits.length > 2)
                          ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                              key: 0,
                              onClick: ($event: any) => (_ctx.removeDepositLine(index)),
                              size: "small"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "3",
            class: "py-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                size: "small",
                elevation: "0",
                color: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addDepositLine()))
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createTextVNode(" Ajouter un acompte ")),
                  _createVNode(_component_v_icon, {
                    icon: "$add",
                    class: "ml-2"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "pt-3 d-flex justify-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "totals text-right" }, [
                _createElementVNode("span", null, "Total des acomptes")
              ], -1),
              _createElementVNode("div", {
                class: "totals text-right",
                style: {"font-weight":"normal"}
              }, [
                _createElementVNode("span", null, "Total de la facture")
              ], -1),
              _createElementVNode("div", { class: "totals text-right" }, [
                _createElementVNode("span", null, "Différence")
              ], -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.depositsTotal, undefined)), 1)
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.grossAmountTotal, undefined)), 1)
              ]),
              _createElementVNode("div", {
                class: "totals text-right",
                style: _normalizeStyle(_ctx.diffDepositAndGrossAmountStyle)
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.diffDepositAndGrossAmountTotals, undefined)), 1)
              ], 4)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "1" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}